// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-container{display:flex;justify-content:start}.header-logo{float:left;display:flex;flex-direction:column;justify-content:center}.header-logo img{display:block}@media(width <= 450px){.header-container{justify-content:center}}", ""]);
// Exports
module.exports = exports;
